import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CVPurchaseService } from './../cv-purchase.service';

@Component({
  selector: 'app-receipt-request',
  templateUrl: './receipt-request.component.html',
  styleUrls: ['./receipt-request.component.css']
})
export class ReceiptRequestComponent {
  receiptForm: FormGroup;
  submitting = false;
  message = '';

  constructor(
    private fb: FormBuilder,
    private purchaseService: CVPurchaseService
  ) {
    this.receiptForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  onSubmit(): void {
    if (this.receiptForm.invalid) return;

    this.submitting = true;
    this.message = '';

    const email = this.receiptForm.value.email;

    this.purchaseService.getReceipt(email).subscribe({
      next: () => {
        this.message = '✅ Receipt sent successfully!';
        this.submitting = false;
        this.receiptForm.reset();
      },
      error: (err) => {
        console.error('Error sending receipt', err);
        this.message = '❌ Failed to send receipt. Please try again.';
        this.submitting = false;
      }
    });
  }
}